@if (vm$ | async; as vm) {
    <frog-upload-drop></frog-upload-drop>
    @if (vm.connectedState === ConnectedState.Disconnected) {
        <div class="flex column justify-center align-items-center blanket">
            <button mat-flat-button color="primary" (click)="reconnect(vm.user)">Reconnect</button>
        </div>
    }
    <div class="root" [class.noselect]="mouseDown">
        <div class="top">
            <mat-toolbar>
                <mat-toolbar-row class="flex justify-space-between">
                    <a [routerLink]="['/s', vm.review.parent_stream_id]">
                        <img src="assets/icons/icon-32x32.png" />
                    </a>
                    <div class="review-name">
                        {{ vm.review.name }}
                    </div>
                    <div class="current-asset">
                        {{ asset?.name }}
                    </div>

                    <div class="flex"></div>

                    <div #link></div>
                    @if (vm.reviewState?.Members.length > 1) {
                        <div #sync class="flex align-items-center justify-end">
                            @if ((syncingState$ | async) === SyncState.Syncing) {
                                <button mat-button (click)="requestLeave()">Leave Sync</button>
                                @switch (presentingState$ | async) {
                                    @case (PresentingState.None) {
                                        <button
                                            mat-icon-button
                                            (click)="requestPresenter(PresentingState.None)"
                                            matTooltip="Start Presenting"
                                        >
                                            <mat-icon>present_to_all</mat-icon>
                                        </button>
                                    }
                                    @case (PresentingState.Self) {
                                        <button
                                            mat-icon-button
                                            (click)="requestPresenter(PresentingState.Self)"
                                            matTooltip="Stop Presenting"
                                        >
                                            <mat-icon>cancel_presentation</mat-icon>
                                        </button>
                                    }
                                    @case (PresentingState.Other) {
                                        <button
                                            mat-icon-button
                                            (click)="requestPresenter(PresentingState.Other)"
                                            matTooltip="Request to be Presenter"
                                        >
                                            <mat-icon>front_hand</mat-icon>
                                        </button>
                                    }
                                }
                            } @else if (vm.reviewState?.isActive()) {
                                <button mat-stroked-button color="primary" (click)="requestJoin()">
                                    Join Sync
                                </button>
                            } @else {
                                <button mat-flat-button color="primary" (click)="requestJoin()">
                                    Start Sync
                                </button>
                            }
                        </div>
                        <div #present></div>
                        <div #members class="align-items-center current-user">
                            @for (member of vm.reviewState?.Members; track member.UserId) {
                                <img
                                    src="{{ member.UserEmail | identicon | async }}"
                                    class="user-icon"
                                    [class.syncing]="member.IsSyncing"
                                    [matTooltip]="member.UserName"
                                />
                            }
                        </div>
                    }
                    <div #user class="align-items-center current-user">
                        <img
                            src="{{ vm.user.email | identicon | async }}"
                            class="user-icon"
                            [matTooltip]="vm.user.name"
                        />
                    </div>
                </mat-toolbar-row>
            </mat-toolbar>
            <div class="flex row flex-100 justify-space-between tools">
                <div #assetListToggle class="flex">
                    @if (startSidenav.opened) {
                        <button mat-button (click)="startSidenav.toggle()" class="small-button">
                            <mat-icon>keyboard_double_arrow_left</mat-icon>
                        </button>
                    } @else {
                        <button mat-button (click)="startSidenav.toggle()">
                            <mat-icon>list</mat-icon>
                            <span
                                >{{ vm.review.children.indexOf(asset) + 1 }}/{{
                                    vm.review.children.length
                                }}</span
                            >
                        </button>
                    }
                    @if (vm.presenterState !== PresentingState.Other && !vm.reviewState?.isComparing()) {
                        <div>
                            <button mat-button (click)="previous(vm)">
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button>
                            <button mat-button (click)="next(vm)">
                                <mat-icon>keyboard_arrow_right</mat-icon>
                            </button>
                        </div>
                    }
                </div>


                <div #tools class="flex drawing-tools">

                        <mat-button-toggle-group [(ngModel)]="tool" [multiple]="false" [hideSingleSelectionIndicator]="true">
                            <mat-button-toggle [value]="AnnotationTool.None" class="small-button" matTooltip="No Annotation">
                                <mat-icon>do_not_touch</mat-icon>
                            </mat-button-toggle>
                            <mat-button-toggle [value]="AnnotationTool.Cursor" class="small-button" matTooltip="Laser Pointer">
                                <mat-icon>stylus_laser_pointer</mat-icon>
                            </mat-button-toggle>
                            <mat-button-toggle [value]="AnnotationTool.Pencil" class="small-button" matTooltip="Brush">
                                <mat-icon>stylus</mat-icon>
                            </mat-button-toggle>
                            <mat-button-toggle [value]="AnnotationTool.Eraser" class="small-button" matTooltip="Eraser">
                                <mat-icon>ink_eraser</mat-icon>
                            </mat-button-toggle>
                        </mat-button-toggle-group>

                        <mat-divider vertical="true"></mat-divider>

                        <div class="swatch-container">
                            <input #hiddenColorPicker type="color" [(ngModel)]="color" (change)="setUserColor()" />
                            <button mat-button class="small-button" (click)="hiddenColorPicker.click()" matTooltip="Annotation Color">
                                <span class="swatch" [style.background-color]="color"></span>
                            </button>
                        </div>

                        <button matButton [matMenuTriggerFor]="sizeMenu" class="small-button" matTooltip="Brush Size">{{size}}</button>
                        <mat-menu #sizeMenu="matMenu">
                            <input mat-menu-item type="range" [min]="2" [max]="40" [(ngModel)]="size" (change)="setUserColor()" />
                        </mat-menu>

                        <button matButton [matMenuTriggerFor]="opacityMenu" class="small-button" matTooltip="Brush Opacity">{{(opacity / 255) * 100 | number:'1.0-0'}}</button>
                        <mat-menu #opacityMenu="matMenu">
                            <input mat-menu-item type="range" [min]="0" [max]="255" [(ngModel)]="opacity" (change)="setUserColor()" />
                        </mat-menu>

                        <mat-divider vertical="true"></mat-divider>

                        <button mat-button (click)="stage.clear()" class="small-button" matTooltip="Clear Annotation">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button mat-button (click)="stage.undo()" class="small-button" matTooltip="Undo">
                            <mat-icon>undo</mat-icon>
                        </button>
                        <button mat-button (click)="stage.redo()" class="small-button" matTooltip="Redo">
                            <mat-icon>redo</mat-icon>
                        </button>

                </div>

                <div #commentListToggle>
                    <button mat-button (click)="endSidenav.toggle()" matTooltip="Toggle Annotations">
                        @if (comments$ | async; as annotations) {
                            @if (endSidenav.opened) {
                                <mat-icon>keyboard_double_arrow_right</mat-icon>
                            } @else {
                                <mat-icon [matBadge]="annotations.length">comment</mat-icon>
                            }
                        }
                    </button>
                </div>
            </div>
        </div>
        <div class="flex flex-100 justify-center">
            <mat-sidenav-container class="flex">
                <mat-sidenav
                    #startSidenav
                    position="start"
                    mode="side"
                    opened="true"
                    class="asset-items-list"
                    (openedChange)="resizeHandler()"
                >
                    @if (vm.presenterState === PresentingState.Other) {
                        <div class="click-blocker"></div>
                    }
                    <div class="asset-list flex column">
                        @for (
                            reviewAsset of vm.review.children;
                            track reviewAsset.id;
                            let i = $index
                        ) {
                            @let role = compareRole(reviewAsset, vm.reviewState);
                            <div
                                (click)="selectRow(reviewAsset, vm.reviewState)"
                                class="asset-item row"
                                [class.active]="reviewAsset.id == asset?.id"
                                [class.compare-a]="role === 'A'"
                                [class.compare-a-active]="role === 'A' && vm.reviewState.ActiveSlot === Slot.Primary"
                                [class.compare-b]="role === 'B'"
                                [class.compare-b-active]="role === 'B' && vm.reviewState.ActiveSlot === Slot.Compare"
                            >
                                <frog-review-asset-item
                                    [asset]="reviewAsset"
                                    [index]="i"
                                    [review]="vm.review"
                                    [compareRole]="role"
                                    (infoLock)="displayInfo = $event"
                                    (toggleCompare)="toggleCompareFlag(reviewAsset, vm.review, vm.reviewState)"
                                ></frog-review-asset-item>
                            </div>
                        }
                        <div class="outer">
                            <div class="inner">
                                <frog-upload-button [parentAsset]="vm.review"></frog-upload-button>
                            </div>
                        </div>
                    </div>
                </mat-sidenav>

                <mat-sidenav
                    position="end"
                    mode="side"
                    opened="false"
                    class="asset-items-list"
                    (openedChange)="resizeHandler()"
                    #endSidenav
                >
                    @if (vm.presenterState === PresentingState.Other) {
                        <div class="click-blocker"></div>
                    }

                    <div class="asset-list flex column">
                        <frog-review-annotation-list
                            class="flex"
                            [asset]="activeAsset()"
                            [slot]="vm.reviewState?.ActiveSlot ?? Slot.Primary"
                        ></frog-review-annotation-list>
                    </div>
                </mat-sidenav>

                <mat-sidenav-content>
                    <frog-review-asset-info [hidden]="!displayInfo" [asset]="activeAsset()" [user]="vm.user" (infoLock)="displayInfo = $event"></frog-review-asset-info>
                    <frog-stage #stage [tool]="tool" [class.no-pointer]="tool === AnnotationTool.None"></frog-stage>

                    @if (vm.reviewState?.isComparing()) {
                        <div class="flex row compare-viewport">
                            @if (asset?.asset_type === compareAsset?.asset_type) {
                                <div class="compare-lock-container">
                                    <button
                                        mat-button
                                        class="small-button compare-lock-button"
                                        (click)="toggleCompareLock(vm.reviewState)"
                                        [attr.aria-pressed]="vm.reviewState.CompareLocked"
                                        [matTooltip]="lockTooltip(vm.reviewState)"
                                    >
                                        <mat-icon>{{ vm.reviewState.CompareLocked ? "lock" : "lock_open" }}</mat-icon>
                                    </button>
                                </div>
                            }
                            <div
                                class="flex column compare-pane compare-a"
                                [class.active]="vm.reviewState.ActiveSlot === Slot.Primary"
                                (click)="setActiveSlot(Slot.Primary, vm.reviewState)"
                            >
                                <div class="compare-pane-header flex row align-items-center">
                                    <span class="compare-badge compare-a-badge" aria-hidden="true">A</span>
                                    <div class="compare-pane-title flex column">
                                        <div class="flex row align-items-center">
                                            <span class="compare-pane-name">{{ asset?.name }}</span>
                                            @if (vm.reviewState.ActiveSlot === Slot.Primary) {
                                                <span class="compare-active-chip">ACTIVE</span>
                                            }
                                        </div>
                                        <span class="compare-pane-owner">{{ asset?.author?.name }}</span>
                                    </div>
                                </div>
                                @switch (asset?.asset_type) {
                                    @case (1) {
                                        <frog-review-image
                                            #assetViewer
                                            [asset]="asset"
                                            [slot]="Slot.Primary"
                                            [isActive]="vm.reviewState.ActiveSlot === Slot.Primary"
                                            class="flex"
                                        ></frog-review-image>
                                    }
                                    @case (2) {
                                        <frog-review-video
                                            #assetViewer
                                            [asset]="asset"
                                            [slot]="Slot.Primary"
                                            [isActive]="vm.reviewState.ActiveSlot === Slot.Primary"
                                            class="flex"
                                        ></frog-review-video>
                                    }
                                }
                            </div>
                            <div
                                class="flex column compare-pane compare-b"
                                [class.active]="vm.reviewState.ActiveSlot === Slot.Compare"
                                (click)="setActiveSlot(Slot.Compare, vm.reviewState)"
                            >
                                <div class="compare-pane-header flex row align-items-center">
                                    <span class="compare-badge compare-b-badge" aria-hidden="true">B</span>
                                    <div class="compare-pane-title flex column">
                                        <div class="flex row align-items-center">
                                            <span class="compare-pane-name">{{ compareAsset?.name }}</span>
                                            @if (vm.reviewState.ActiveSlot === Slot.Compare) {
                                                <span class="compare-active-chip">ACTIVE</span>
                                            }
                                        </div>
                                        <span class="compare-pane-owner">{{ compareAsset?.author?.name }}</span>
                                    </div>
                                </div>
                                @switch (compareAsset?.asset_type) {
                                    @case (1) {
                                        <frog-review-image
                                            #assetViewer
                                            [asset]="compareAsset"
                                            [slot]="Slot.Compare"
                                            [isActive]="vm.reviewState.ActiveSlot === Slot.Compare"
                                            class="flex"
                                        ></frog-review-image>
                                    }
                                    @case (2) {
                                        <frog-review-video
                                            #assetViewer
                                            [asset]="compareAsset"
                                            [slot]="Slot.Compare"
                                            [isActive]="vm.reviewState.ActiveSlot === Slot.Compare"
                                            class="flex"
                                        ></frog-review-video>
                                    }
                                }
                            </div>
                        </div>
                    } @else {
                        @switch (asset?.asset_type) {
                            @case (1) {
                                <frog-review-image
                                    #assetViewer
                                    [asset]="asset"
                                    class="flex"
                                ></frog-review-image>
                            }
                            @case (2) {
                                <frog-review-video
                                    #assetViewer
                                    [asset]="asset"
                                    class="flex"
                                ></frog-review-video>
                            }
                        }
                    }
                </mat-sidenav-content>
            </mat-sidenav-container>
        </div>
        @if (vm.presenterState !== PresentingState.Other) {
            @if (activeAsset()?.asset_type === 2) {
                <div class="bottom column">
                    <frog-review-timeline [slot]="vm.reviewState?.ActiveSlot ?? Slot.Primary"></frog-review-timeline>
                    @if (annotations$ | async; as annotations) {
                        <div #tools class="flex row flex-100 tools">
                            <div class="flex justify-start">
                                <button
                                    mat-button
                                    class="small-button"
                                    (click)="previousAnnotationMarker(vm.playbackState.frame,annotations)"
                                    matTooltip="Jump to previous annotation"
                                >
                                    <mat-icon>arrow_menu_close</mat-icon>
                                </button>
                                <button
                                    mat-button
                                    class="small-button"
                                    (click)="nextAnnotationMarker(vm.playbackState.frame, annotations)"
                                    matTooltip="Jump to next annotation"
                                >
                                    <mat-icon>arrow_menu_open</mat-icon>
                                </button>
                                <button
                                    mat-button
                                    class="small-button"
                                    [class.active]="looping"
                                    (click)="loopChange()"
                                    matTooltip="Loop"
                                >
                                    <mat-icon>repeat</mat-icon>
                                </button>

                                <button
                                    mat-button
                                    class="small-button"
                                    [class.active]="vm.playbackState.playRange?.start !== null"
                                    (click)="setRangeStart(vm.playbackState)"
                                    matTooltip="Set start of playback range"
                                >
                                    <mat-icon>text_select_jump_to_beginning</mat-icon>
                                </button>
                                <button
                                    mat-button
                                    class="small-button"
                                    [class.active]="vm.playbackState.playRange?.end !== null"
                                    (click)="setRangeEnd(vm.playbackState)"
                                    matTooltip="Set end of playback range"
                                >
                                    <mat-icon>text_select_jump_to_end</mat-icon>
                                </button>
                            </div>
                            <div class="flex justify-end">
                                <button mat-button class="small-button" (click)="muteChange()" matTooltip="Mute">
                                    <mat-icon>{{ muted ? "volume_off" : "volume_up" }}</mat-icon>
                                </button>
                                <input type="range" [(ngModel)]="volume" (input)="volumeChange()" />
                            </div>
                        </div>
                    }
                </div>
            }
        }
    </div>
}
